// extracted by mini-css-extract-plugin
module.exports = {"timeline":"Timeline_timeline__1ehGt","spinner":"Timeline_spinner__2nyaK","svg":"Timeline_svg__u9U9S"};